/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2019 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../../core/IceEntity';
import { IceTypes } from '../../icetypes';

export class subtypeitem extends IceEntity {
  sub_type: number = 0;
  category_type: number = 0;
  code: string = "";
  title: string = "";
  keyword: string = "";
  description: string = "";

  gettablename(): string {
    return "SUBTYPE_ITEM";
  }
}
